import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

const LANGUAGES = [
  { code: "es", label: "Español" },
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "ro", label: "Română" },
  { code: "ar", label: "العربية" },
  { code: "zh-CN", label: "中文" },
  { code: "de", label: "Deutsch" },
  { code: "it", label: "Italiano" },
  { code: "pt", label: "Português" },
  { code: "ru", label: "Русский" },
  { code: "uk", label: "Українська" },
  { code: "pl", label: "Polski" },
  { code: "bg", label: "Български" },
  { code: "sq", label: "Shqip" },
  { code: "hi", label: "हिन्दी" },
  { code: "ur", label: "اردو" },
  { code: "bn", label: "বাংলা" },
  { code: "tr", label: "Türkçe" },
  { code: "nl", label: "Nederlands" },
  { code: "ja", label: "日本語" },
  { code: "ko", label: "한국어" },
  { code: "ca", label: "Català" },
  { code: "eu", label: "Euskara" },
  { code: "gl", label: "Galego" },
];

const getCurrentLang = () => {
  const m = document.cookie.match(/googtrans=\/es\/([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "es";
};

const setLang = (code) => {
  const expire = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
  const parts = window.location.hostname.split(".");
  const domains = [""];
  for (let i = 0; i < parts.length - 1; i++) {
    const suffix = parts.slice(i).join(".");
    domains.push(`; domain=${suffix}`, `; domain=.${suffix}`);
  }
  domains.forEach((d) => {
    document.cookie = `googtrans=; ${expire}; path=/${d}`;
  });
  if (code !== "es") {
    document.cookie = `googtrans=/es/${code}; path=/`;
  }
  window.location.reload();
};

export const LanguageSwitcher = () => {
  const current = getCurrentLang();
  const currentLabel = LANGUAGES.find((l) => l.code === current)?.label || "Español";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" data-testid="language-switcher-btn"
          className="rounded-full text-slate-600 hover:text-cyan-600 px-2 sm:px-3 notranslate">
          <Globe className="h-4 w-4" />
          <span className="ml-1.5 hidden lg:inline text-sm">{currentLabel}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-80 overflow-y-auto notranslate" data-testid="language-menu">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem key={l.code} data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)} className="cursor-pointer justify-between gap-4">
            {l.label}
            {current === l.code && <Check className="h-4 w-4 text-cyan-500" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
